import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../services/api";

const KycCompleted = () => {
  const [searchParams] = useSearchParams();
  const hasTriggeredRef = useRef(false);
  const [status, setStatus] = useState("loading");

  const callbackAuthToken = useMemo(
    () => searchParams.get("callbackAuthToken") || searchParams.get("token") || "",
    [searchParams]
  );

  useEffect(() => {
    if (hasTriggeredRef.current) return;
    hasTriggeredRef.current = true;

    const hitKycWebhook = async () => {
      if (!callbackAuthToken) {
        setStatus("token_missing");
        return;
      }

      try {
        await api.get("/webhook/digilocker-kyc", {
          headers: {
            Authorization: `Bearer ${callbackAuthToken}`,
            "x-content-source": "RIAFY",
          },
        });
        setStatus("success");
      } catch {
        setStatus("error");
      }
    };

    hitKycWebhook();
  }, [callbackAuthToken]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 px-4 py-10 flex items-center justify-center">
      <div className="w-full max-w-md rounded-2xl border border-emerald-100 bg-white/90 shadow-xl backdrop-blur p-8 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            className="h-7 w-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-semibold text-gray-900">
          KYC Completed Successfully
        </h1>
        {status === "loading" && (
          <p className="mt-3 text-base text-gray-600">
            Verifying your KYC details, please wait...
          </p>
        )}
        {status === "success" && (
          <p className="mt-3 text-base text-gray-600">
            Your KYC has been successfully completed.
          </p>
        )}
        {status === "token_missing" && (
          <p className="mt-3 text-base text-red-600">
            KYC token missing. Please retry from the DigiLocker flow.
          </p>
        )}
        {status === "error" && (
          <p className="mt-3 text-base text-red-600">
            We could not verify KYC right now. Please try again.
          </p>
        )}
      </div>
    </div>
  );
};

export default KycCompleted;
